<div class="loader-full">
    <i-loader></i-loader>
</div>
